'use client';

import { createPortal } from 'react-dom';
import { type ReactNode } from 'react';

type MentionsMenuPortalProps = {
  children: ReactNode;
};

export function MentionsMenuPortal({ children }: MentionsMenuPortalProps) {
  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <div data-outside-interaction-safe style={{ display: 'contents' }}>
      {children}
    </div>,
    document.body,
  );
}
